import axios from 'axios'

const state = {
    product: '',
}

const getters = {
    getProduct: state => state.product,
}

const actions = {
}

const mutations = {
    setNameClient: (state, nameClient) => (state.nameClient = nameClient),
}
export default {
    state,
    getters,
    actions,
    mutations
}